// Generated from Figma Design Guidelines

export const ProductLineReferenceToVideo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.57617 7.8501L12.0001 12.1167L19.4241 7.8501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 20.65V12.1167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20.0553 11.9997V9.08176C20.0553 8.00996 19.4835 7.01958 18.5553 6.48368L13.5013 3.56573C12.5731 3.02983 11.4295 3.02983 10.5013 3.56573L5.44727 6.48368C4.51906 7.01958 3.94727 8.00996 3.94727 9.08176V14.9177C3.94727 15.9895 4.51906 16.9798 5.44727 17.5157L10.5013 20.4337C11.4295 20.9696 12.5731 20.9696 13.5013 20.4337L14.0148 20.1372"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.332 16.5542C19.4929 16.8969 19.7678 17.1724 20.1104 17.3335C19.7681 17.4945 19.493 17.7695 19.332 18.1118C19.1709 17.7693 18.8954 17.4944 18.5527 17.3335C18.8957 17.1725 19.171 16.8971 19.332 16.5542Z"
      stroke="currentColor"
      strokeWidth="2.25"
    />
  </svg>
);
